
import React from "react";
import "./Checkbox.css";

interface CheckboxProps {
  label: string;
  checked: boolean;
  onCheck: () => void;
  children?: React.ReactNode;
}

export const Checkbox = ({ label, checked, onCheck, children }: CheckboxProps) => {
  return (
    <div className="checkbox" onClick={onCheck}>
      <div className={`checkbox_box ${checked ? 'checkbox_box--checked' : ''}`}></div>
      <div className="checkbox_label">{label || children}</div>
    </div>
  );
};
